import styled from 'styled-components';

export const AreaAbsolute = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 9999;
`;
export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  background-color: ${({ theme }) => theme.pantone656C};
  padding: 1rem;
  border-radius: 24px 24px 0 0;

  /* styled LInk */
  a {
    :hover {
      text-decoration: underline;
    }
  }
`;

export const Text = styled.div`
  color: ${({ theme }) => theme.pantoneBlack};
  text-align: left;
`;

export const BlockPage = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
`;

